export default {
  session: '',
  channels: [],
  selectedChannels: [],

  loadingChannels: false,
  loadingChannelsFailed: false,
  loadingChannelsSuccess: false,

  loadingChannelLinks: false,
  loadChannelLinksFailed: false,
  loadChannelLinksSuccess: false,

  /** Facebook */
  facebookPagePollInterval: null,
  gettingFacebookPages: false,
  addingFacebookPage: false,
  facebookPages: [],

  instagramPagePollInterval: null,
  gettingInstagramPages: false,
  addingInstagramPage: false,
  instagramPages: [],

  /** Instagram & twitter */
  addingTwitterChannel: false,
  addingEmailChannel: false,

  /** Tiktok */
  addingTiktokChannel: false,
  tiktokCreator: null,
  tiktokCreatorLoading: false,
  tiktokCreatorError: null,

  addingWechatChannel: false,
  addingWhatsappChannel: false,

  requestingWhatsappCode: false,
  requestWhatsappAuthCodeSuccess: false,
  requestWhatsappAuthCodeFailure: false,

  updateChannelRequest: false,
  updateChannelSuccess: false,
  updateChannelFailed: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/channel/state.js